"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.pageFactory = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var fields_1 = require("../../../fields");
var document_factory_1 = require("../document-factory");
var FREQUENCY_PRISMIC_TO_LGLP = {
    hebdomadaire: types_1.FrequenciesEnum.Weekly,
    toujours: types_1.FrequenciesEnum.Always,
    'toutes les heures': types_1.FrequenciesEnum.Hourly,
    quotidienne: types_1.FrequenciesEnum.Daily,
    mensuelle: types_1.FrequenciesEnum.Monthly,
    annuelle: types_1.FrequenciesEnum.Yearly,
    jamais: types_1.FrequenciesEnum.Never
};
var processPage = function (prismicDoc, normalizedDoc, logger) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return utils_1.compact(__assign(__assign({}, normalizedDoc), { type: normalizedDoc.type, meta: utils_1.compact({
            title: fields_1.toText((_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.seo_meta_title) ||
                fields_1.toText((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.title),
            description: fields_1.toText((_c = prismicDoc.data) === null || _c === void 0 ? void 0 : _c.seo_meta_description),
            image: fields_1.toImage((_d = prismicDoc.data) === null || _d === void 0 ? void 0 : _d.seo_meta_image, logger),
            indexed: fields_1.toBoolean((_e = prismicDoc.data) === null || _e === void 0 ? void 0 : _e.seo_meta_indexing, {
                defaultValue: true
            })
        }), seoText: fields_1.toText((_f = prismicDoc.data) === null || _f === void 0 ? void 0 : _f.seo_text), sitemapPriority: fields_1.toNumber((_g = prismicDoc.data) === null || _g === void 0 ? void 0 : _g.seo_sitemap_priority, {
            min: 0,
            max: 1,
            defaultValue: 0.8
        }), sitemapChangeFrequency: toFrequency((_h = prismicDoc.data) === null || _h === void 0 ? void 0 : _h.seo_sitemap_change_frequency) ||
            types_1.FrequenciesEnum.Weekly, breadcrumbParent: fields_1.toDocumentLink((_j = prismicDoc.data) === null || _j === void 0 ? void 0 : _j.seo_breadcrumb_parent, logger), breadcrumb: logger.required(fields_1.toText(((_k = prismicDoc.data) === null || _k === void 0 ? void 0 : _k.breadcrumb) ||
            ((_l = prismicDoc.data) === null || _l === void 0 ? void 0 : _l.title) ||
            ((_m = prismicDoc.data) === null || _m === void 0 ? void 0 : _m.seo_meta_title))), title: logger.required(fields_1.toText((_o = prismicDoc.data) === null || _o === void 0 ? void 0 : _o.title)), disableRgpbBanner: fields_1.toBoolean((_p = prismicDoc.data) === null || _p === void 0 ? void 0 : _p.disableRgpd), maintenance: fields_1.toBoolean((_q = prismicDoc.data) === null || _q === void 0 ? void 0 : _q.maintenance) }));
};
var toFrequency = function (prismicFrequency) {
    return prismicFrequency && FREQUENCY_PRISMIC_TO_LGLP[prismicFrequency];
};
var pageFactory = function (type, next) {
    return document_factory_1.documentFactory(type, function (prismicDoc, normalizedDoc, logger) {
        var normalizedPage = processPage(prismicDoc, normalizedDoc, logger);
        return next(prismicDoc, normalizedPage, logger);
    });
};
exports.pageFactory = pageFactory;
//# sourceMappingURL=page-factory.js.map